import axios from "axios";
import authHeader from './auth.header';
const API_URL = "https://contabilidadelider.com/api/usuario/";
class AuthService {
  login(user) {
    return axios
      .post(API_URL + "signin", {
        email: user.email,
        senha: user.senha,
      })
      .then((response) => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }
  register(
    nome,
    genero,
    foto,
    pis,
    dataEntrada,
    jornadaSemanal,
    setores,
    email,
    senha
  ) {
    setores.unshift("Assuntos Gerais");
    return axios.post(
      API_URL + "novoUsuario",
      {
        nome: nome,
        genero: genero,
        foto: foto,
        pis: pis,
        dataEntrada: dataEntrada,
        jornadaSemanal: jornadaSemanal,
        setores: setores,
        email: email,
        senha: senha,
      }, { headers: authHeader() }
    );
  }
  logout() {
    localStorage.removeItem("user");
  }

  /* register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }*/
}

export default new AuthService();
